/**
 * @generated SignedSource<<5cc5cf3f2bc9606d752cd06da4a2152c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FiatTransactionStatus = "APPROVED" | "CANCELLED" | "CREDITED" | "FINISHED" | "INITIATED" | "MANUAL_REVIEW" | "PENDING" | "PROCESSING" | "REFUNDED" | "REJECTED";
export type FiatTransactionType = "DEPOSIT" | "WITHDRAWAL";
export type CreateFiatWithdrawalInput = {
  amount: string;
  code: string;
  fiatId?: string | null | undefined;
  payoutAccountId?: string | null | undefined;
  tradeId?: string | null | undefined;
};
export type CreateFiatWithdrawalMutation$variables = {
  input: CreateFiatWithdrawalInput;
};
export type CreateFiatWithdrawalMutation$data = {
  readonly createFiatWithdrawal: {
    readonly amount: PrecisionFloat;
    readonly createdAt: TimeScalar;
    readonly fee: PrecisionFloat;
    readonly fiat: {
      readonly id: string;
      readonly symbol: string | null | undefined;
    };
    readonly id: string;
    readonly payoutAccount: {
      readonly bankName: string | null | undefined;
      readonly iban: string;
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly status: FiatTransactionStatus;
    readonly type: FiatTransactionType;
  } | null | undefined;
};
export type CreateFiatWithdrawalMutation = {
  response: CreateFiatWithdrawalMutation$data;
  variables: CreateFiatWithdrawalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FiatTransaction",
    "kind": "LinkedField",
    "name": "createFiatWithdrawal",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fee",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Fiat",
        "kind": "LinkedField",
        "name": "fiat",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "symbol",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PayoutAccount",
        "kind": "LinkedField",
        "name": "payoutAccount",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "iban",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bankName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateFiatWithdrawalMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateFiatWithdrawalMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0c41624b4fc6ecdf07ddc3201a93adef",
    "id": null,
    "metadata": {},
    "name": "CreateFiatWithdrawalMutation",
    "operationKind": "mutation",
    "text": "mutation CreateFiatWithdrawalMutation(\n  $input: CreateFiatWithdrawalInput!\n) {\n  createFiatWithdrawal(input: $input) {\n    id\n    status\n    type\n    amount\n    fee\n    fiat {\n      id\n      symbol\n    }\n    payoutAccount {\n      id\n      name\n      iban\n      bankName\n    }\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d91fb50f42ce495623ec4da866c1060";

export default node;
